import extend from 'extend';
import { unflatten } from 'flat';

import localConfig from './local';
import defaultConfig from './default';

const config = extend(true, unflatten(defaultConfig), unflatten(localConfig));

export default config;
